import { InjectionToken } from '@angular/core';

export const API_LANDINGS_SERVICE_URL = new InjectionToken<string>('API_LANDINGS_SERVICE_URL');

export const EDUCATION_SERVICE_URL = new InjectionToken<string>('EDUCATION_SERVICE_URL');

export const SOA_ID = new InjectionToken<string>('SOA_ID');

export const SOA_SECRET = new InjectionToken<string>('SOA_SECRET');

export const SOA_URL = new InjectionToken<string>('SOA_URL');

export const X_REAL_IP = new InjectionToken<string>('X_REAL_IP');
